var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignedTotalTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60349 3.5675L7.60349 3.56749C7.6437 3.49785 7.70153 3.44002 7.77117 3.39981C7.84082 3.35961 7.91981 3.33844 8.00023 3.33844C8.08065 3.33844 8.15965 3.35961 8.22929 3.39981C8.29893 3.44002 8.35676 3.49785 8.39697 3.56749L13.0542 11.6344L13.0543 11.6344C13.0945 11.7041 13.1157 11.7831 13.1157 11.8636C13.1157 11.944 13.0945 12.023 13.0543 12.0927C13.0141 12.1624 12.9562 12.2202 12.8865 12.2605C12.8169 12.3007 12.7378 12.3219 12.6574 12.3219H12.6574H3.34261H3.34257C3.26211 12.3219 3.18308 12.3007 3.11341 12.2605C3.04374 12.2202 2.98589 12.1624 2.94566 12.0927C2.90544 12.023 2.88427 11.944 2.88428 11.8636C2.88428 11.7831 2.90547 11.7041 2.94571 11.6344L2.94574 11.6344L7.60349 3.5675Z",
    stroke: "#FF0004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06107 5.80548H7.93957C7.64044 5.80548 7.39795 6.04797 7.39795 6.34711V8.93598C7.39795 9.23511 7.64044 9.47761 7.93957 9.47761H8.06107C8.36021 9.47761 8.6027 9.23511 8.6027 8.93598V6.34711C8.6027 6.04797 8.36021 5.80548 8.06107 5.80548Z",
    fill: "#FF0004"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00032 11.5309C8.33301 11.5309 8.6027 11.2612 8.6027 10.9285C8.6027 10.5958 8.33301 10.3261 8.00032 10.3261C7.66764 10.3261 7.39795 10.5958 7.39795 10.9285C7.39795 11.2612 7.66764 11.5309 8.00032 11.5309Z",
    fill: "#FF0004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedTotalTasks);
export default __webpack_public_path__ + "static/media/assignedTotalTasks.2f305b5c9750c0407a16e3a2ee4daaf1.svg";
export { ForwardRef as ReactComponent };